/**
 * @module store/foundations/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив e-mails (текущую "страницу")
 *
 * @returns {array}
 */
const foundations = state => state.foundations;


/**
 * Getter: Возвращает общее число e-mails
 *
 * @returns {number}
 */
const foundationsCount = state => state.total;


/**
 * Getter: Возвращает флаг, загружаются ли в текущий момент e-mails
 *
 * @returns {boolean}
 */
const isFoundationsLoading = state => state.isLoading;


export default {
  foundations,
  foundationsCount,
  isFoundationsLoading,
};
